import React from "react";
const StartNode = () => {
  return (
    <div className="flex items-center gap-1 px-3.5 py-2.5 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-800 rounded-lg shadow-sm hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors text-[0.715rem] font-inter text-gray-700 dark:text-gray-200">
      Sequence Start
    </div>
  );
};

export default StartNode;
